import React from 'react';

import { NumberInput, SelectInput } from 'react-admin';

import { Box } from '@mui/material';

import { ruleOverviewRuleTypes } from '../../../../constants/ruleTypes';
import RuleSelector from '../../../utils/RuleSelector';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const ruleTypeChoices = [
  { id: ruleOverviewRuleTypes.REQUEST, name: 'Request' },
  { id: ruleOverviewRuleTypes.ONGOING, name: 'Ongoing' },
  { id: ruleOverviewRuleTypes.BOTH, name: 'Both' },
];

const numberRangeValidation = (
  _value: Number,
  allValues: { report: { fromVersion: Number; toVersion: Number | null } },
) => {
  const { fromVersion, toVersion } = allValues.report || {};
  if (fromVersion !== undefined && toVersion !== undefined && toVersion !== null) {
    if (fromVersion > toVersion) {
      return 'fromVersion should be less than or equal to toVersion';
    }
  }
  return undefined;
};

const versionValidation = (value: number): string | undefined => {
  if (value === undefined || value === null) return undefined;
  if (value < 0) return 'Version should be 0 or higher';
  if (!Number.isInteger(value)) return 'Version should be a whole number';
  return undefined;
};

const RuleOverview = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Version range" description="Only rules with at least one version number within this range are included. 'From version' defaults to 0; leave 'to version' empty for no upper limit.">
      <RangeFields
        from={(
          <NumberInput
            fullWidth
            source="report.fromVersion"
            label="From version"
            min={0}
            step={1}
            validate={[versionValidation, numberRangeValidation]}
            helperText={false}
          />
        )}
        to={(
          <NumberInput
            fullWidth
            source="report.toVersion"
            label="To version"
            min={0}
            step={1}
            validate={[versionValidation, numberRangeValidation]}
            helperText={false}
          />
        )}
      />
    </FieldBox>
    <FieldBox title="Rules" description="Filter to only include rules with these origination IDs. Leave empty to include all rules.">
      <RuleSelector source="report.originationRuleIds" label="Rules" field="id" helperText={false} />
    </FieldBox>
    <FieldBox title="Rule type" description="Filter by rule execution type: 'Request' rules trigger on requests, 'Ongoing' rules run on all entities once a day. Select 'Both' to include all types. Default: 'Both'.">
      <SelectInput
        fullWidth
        source="report.ruleType"
        label=""
        choices={ruleTypeChoices}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Test versions" description="Yes: include only test rule versions. No: include only non-test rule versions. Default: No.">
      <SelectInput
        fullWidth
        source="report.testVersions"
        label=""
        choices={[
          { id: 0, name: 'No' },
          { id: 1, name: 'Yes' },
        ]}
        helperText={false}
      />
    </FieldBox>
  </Box>
);

export default RuleOverview;
